module.exports = __webpack_public_path__ + "img/21_109.9c5d5845.png";